var map = {
	"./en.auth.json": "./dist/core/locale/en.auth.json",
	"./en.common.json": "./dist/core/locale/en.common.json",
	"./en.context.json": "./dist/core/locale/en.context.json",
	"./en.core.json": "./dist/core/locale/en.core.json",
	"./en.geo.json": "./dist/core/locale/en.geo.json",
	"./en.integration.json": "./dist/core/locale/en.integration.json",
	"./en.json": "./dist/core/locale/en.json",
	"./fr.auth.json": "./dist/core/locale/fr.auth.json",
	"./fr.common.json": "./dist/core/locale/fr.common.json",
	"./fr.context.json": "./dist/core/locale/fr.context.json",
	"./fr.core.json": "./dist/core/locale/fr.core.json",
	"./fr.geo.json": "./dist/core/locale/fr.geo.json",
	"./fr.integration.json": "./dist/core/locale/fr.integration.json",
	"./fr.json": "./dist/core/locale/fr.json",
	"./zh-TW.auth.json": "./dist/core/locale/zh-TW.auth.json",
	"./zh-TW.common.json": "./dist/core/locale/zh-TW.common.json",
	"./zh-TW.context.json": "./dist/core/locale/zh-TW.context.json",
	"./zh-TW.core.json": "./dist/core/locale/zh-TW.core.json",
	"./zh-TW.geo.json": "./dist/core/locale/zh-TW.geo.json",
	"./zh-TW.integration.json": "./dist/core/locale/zh-TW.integration.json",
	"./zh-TW.json": "./dist/core/locale/zh-TW.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./dist/core/locale sync recursive ^\\.\\/.*\\.json$";